import supabase from "../../../shared/database/supabase";
import { Car, CarRepository } from "../model/car";


export const updateCar = async (car: Car) => {
    try {
        console.log("Updating car with data:", car);
        const { data, error } = await supabase.functions.invoke<CarRepository>("update-car", {
            body: JSON.stringify({
                id: car.id,
                brand: car.brand,
                model: car.model,
                plate: car.plate,
                color: car.color,
                chassis_number: car.chassisNumber,
                insurance_name: car.insuranceName,
                costumer_id: car.costumerId,
                mileage: car.mileage ?? null,
            }),
        });

        if (error) {
            console.error("Error calling update-car:", error);
            return { data: null, error };
        }
        return { data: data, error: null };
    } catch (err) {
        console.error("Exception in updateCar:", err);
        throw err;
    }
};
